<template>
	<div>
		<div class="createorder" v-show="isexists&&isload" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<el-form>
				<el-row>
					<el-col v-for="(item,index) in pageset" :key="index" 
					v-if="item.l_mode=='主信息-详情'" :span="24">
						<ordermain ref="ordermain" l_mode="主信息-详情"></ordermain>
					</el-col>
					
					<el-col v-for="(item,index) in pageset" :key="index"
					v-if="item.l_mode=='寄件人信息-详情'" :span="12">
						<senderaddr ref="senderaddr" title="寄件信息" l_mode="寄件人信息-详情"></senderaddr>
					</el-col>
					<el-col v-for="(item,index) in pageset" :key="index"
					v-if="item.l_mode=='收件人信息-详情'" :span="12">
						<receiveraddr ref="receiveraddr" title="收件信息" l_mode="收件人信息-详情"></receiveraddr>
					</el-col>
					<el-col v-for="(item,index) in pageset" :key="index"
					v-if="item.l_mode=='商品列表-详情'" :span="24">
						<ordercargolist ref="ordercargolist" title="商品信息" l_mode="商品列表-详情" gridheight="200px"></ordercargolist>
					</el-col>
					<el-col v-for="(item,index) in pageset" :key="index"
					v-if="item.l_mode=='包裹信息-详情'" :span="24">
						<packagelist ref="packagelist" title="包裹信息" l_mode="包裹信息-详情"></packagelist>
					</el-col>
					<el-col :span="12" v-for="(item,index) in pageset" :key="index"
					v-if="item.l_mode=='附加信息-详情'">
						<orderextend ref="orderextend" title="附加信息" l_mode="附加信息-详情"></orderextend>
					</el-col>
					<el-col :span="12" v-for="(item,index) in pageset" :key="index"
					v-if="item.l_mode=='操作日志-详情'"><orderlog ref="orderlog" title="日志" l_mode="操作日志-详情"></orderlog></el-col>
				</el-row>
			</el-form>
		</div>
		<div style="{height:`${windowHeight}px`,'overflow-y': 'scroll'}" v-show="!isexists&&isload">
			<el-row>
				<el-col style="text-align:center">
					<i class="el-icon-error" style="color:orangered;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">订单已删除</span>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import senderaddr from '@/components/address/senderaddr_ssq.vue';
import receiveraddr from '@/components/address/receiveraddr_ssq.vue';
import ordercargolist from '@/components/order/ordercargolist.vue';
import orderlog from '@/components/order/orderlog.vue';
import orderextend from '@/components/order/orderextend.vue';
import ordermain from '@/components/order/ordermain.vue';
import packagelist from '@/components/order/export_package_list.vue';

export default {
	components: {
		senderaddr,
		receiveraddr,
		ordercargolist,
		orderlog,
		ordermain,
		orderextend,
		packagelist
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			isexists:false,
			isload:false,
			p_pkval:'',
			orderinfo:{},
			pageset:[],
			l_mode:'详情',
			divclass:'createorder',
			windowHeight: window.innerHeight - 120
		}
	},
	mounted() {
		if (this.urlparam.pkval != undefined) {
			this.p_pkval = this.urlparam.pkval;
		}
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/createorder.scss');
			this.GetOrderInfo();
		});
	},
	methods: {
		GetOrderInfo(){
			if(this.p_pkval!=''){
				this.$tool.loading('正在加载', this.divclass);
				var that=this;
				that.isload=false;
				this.$apipost.get.GetOrderInfo_More({pkval:this.p_pkval}).then(res => {
					that.isload=true;
					if(res.state=='1'){
						that.isexists=true;
						that.orderinfo=res.orderinfo;
						that.GetPagecolGroup();
					}else{
						this.$tool.loadingclose();
						that.isexists=false;
						this.$tool.message(res.message,"0");
					}
				});
			}
		},
		GetPagecolGroup(){
			var that=this;
			this.$apipost.get.GetPagecolGroup({l_mode: this.l_mode }).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					that.pageset=res.list;
					that.GetLayOut();
				}
			}).catch(e=>{
				that.GetPagecolGroup();
			});
		},
		GetLayOut(){
			var that=this;
			this.$nextTick(function() {
				that.pageset.forEach(e=>{
					if(e.l_mode=='主信息-详情')
						that.$refs.ordermain[0].init({ syscol:'', orderinfo: that.orderinfo,isdetail:true});
					if(e.l_mode=='寄件人信息-详情')
						that.$refs.senderaddr[0].init({ syscol:'', orderinfo: that.orderinfo,isdetail:true});
					if(e.l_mode=='收件人信息-详情')
						that.$refs.receiveraddr[0].init({ syscol: '', orderinfo: that.orderinfo,isdetail:true });
					if(e.l_mode=='商品列表-详情')
						that.$refs.ordercargolist[0].init({ syscol: '', orderinfo: that.orderinfo,isdetail:true});
					if(e.l_mode=='附加信息-详情')
						that.$refs.orderextend[0].init({ syscol: '', orderinfo: that.orderinfo,isdetail:true});
					if(e.l_mode=='操作日志-详情')
						that.$refs.orderlog[0].init({ syscol:'', orderinfo:that.orderinfo});
					if(e.l_mode=='包裹信息-详情')
						that.$refs.packagelist[0].init({ syscol:'', orderinfo: that.orderinfo,isaddpackage:false,
						l_mode_cargo:'包裹信息列表-详情',isdetail:true});
									
				});
			});
		}
	}
}
</script>

<style>
</style>
